import {
  firstNameIcon,
  lastNameIcon,
  corporateIcon,
  emailIcon,
  passwordIcon,
  passwordConfirmIcon,
} from "assets/icons";

export const accountDetailsForSignUp = [
  {
    name: "first_name",
    placeHolder: "modal.register.firstName",
    icon: firstNameIcon,
    type: "text",
    required: true,
  },
  {
    name: "last_name",
    placeHolder: "modal.register.lastName",
    icon: lastNameIcon,
    type: "text",
    required: true,
  },
  {
    name: "social_reason",
    placeHolder: "modal.register.corporateName",  // ← Changed from "company" to "corporateName" to match your translation key
    icon: corporateIcon,
    type: "text",
  },
  {
    name: "phone",
    placeHolder: "modal.register.phone",
    type: "tel",
    required: true,
  },
  {
    name: "email",
    placeHolder: "modal.register.email",
    icon: emailIcon,
    type: "email",
    required: true,
  },
  {
    name: "password",
    placeHolder: "modal.register.password",
    icon: passwordIcon,
    type: "password",
    required: true,
  },
  {
    name: "password_confirmation",
    placeHolder: "modal.register.passwordConfirmation",
    icon: passwordConfirmIcon,
    type: "password",
    required: true,
  },
];